import React from 'react'
import { Route, Redirect, RouteProps } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { usePath } from 'lib/core/hooks'
import { getIsLoggedIn } from 'lib/core/data/auth/session/selectors'

interface Props {
  component: React.ComponentType<any>
}

export const PrivateRoute: React.FC<Props & RouteProps & {}> = ({ component: Component, ...rest }) => {
  const path = usePath()
  const isLoggedIn = useSelector(getIsLoggedIn)
  return (
    <Route
      {...rest}
      render={props => {
        if (isLoggedIn) {
          return (
            <Component {...props} />
          )
        } else {
          return (
            <Redirect
              to={{
                pathname: path.login,
                state: { from: props.location }
              }}
            />
          )
        }
      }}
    />
  )
}
